import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ theme, displayState }) => css`
    padding: ${`${displayState?.paddingY ?? '8px'} ${displayState?.paddingX ?? '20px'}`};;
    
    &:hover {
      background-color: ${`${theme?.colour?.primary}0D`};
    }
  `}
`;

export default Wrapper(template);
